import React, { Component, useState } from "react";
import CartContext from "./CartContext";
import { Country, State, City } from "country-state-city";
import { Navigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { LoadSpinner } from "./LoadSpinner";

import {
  Stack,
  Form,
  Nav,
  Row,
  Col,
  FloatingLabel,
  Button,
  Card,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import { HomeCarousels } from "./HomeCarosels";
import { RetailPosPricing, RestaurantPosPricing } from "./Pricing";
import IncDecCounter from "./IncDecCounterControl";

export class Checkout extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      validated: false,
      userData: {},
      businessName: "",
      businessShortName: "",
      autoScale: false,
      transactionCharges: 0,
      businessCategoryId: "",
      businessDescription: "",
      businessPanNumber: "",
      businessTaxNumber: "",
      address: "",
      city: "",
      state: "",
      country: "",
      pinCode: "",
      contactNo: "",
      emailId: "",
      selectedLicenseType: "",
      selectedLicensePeriod: 12,
      selectedRetentionMonths: 24,
      selectedRetentionCost: 499,
      totalUsers: 1,
      CouponCode: "",
      CouponValue: 0,
      enableSEO: false,
      acceptTermsAndConditions: false,
      loadSpinnerOpen: false,
      IsStoreShortNameAvailable: false,
    };
  }
  ShowLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: true });
  };
  HideLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: false });
  };

  GetUserData = () => {
    console.log(`Bearer ${this.context.userData.bearerToken}`);

    var requestData = "";
    if (this.context.GetEcSettingValueByName("loginMethod") == "SMS") {
      requestData =
        "Sales/GetTenantBycontactNo/" + this.context.userData.contactNo;
    } else if (this.context.GetEcSettingValueByName("loginMethod") == "EMAIL") {
      requestData = "Sales/GetTenantByEmailId/" + this.context.userData.emailId;
    } else return;

    fetch(
      process.env.REACT_APP_API + requestData,

      {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${this.context.userData.bearerToken}`,
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        data = JSON.parse(data);
        this.setState({ userData: data });
        this.context.storeUserData(data);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  OnUpdateUserData = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case "businessName":
        this.state.userData.businessName = value;
        break;
      case "businessShortName":
        this.state.userData.businessShortName = value;
        break;

      case "firstName":
        this.state.userData.firstName = value;
        break;
      case "contactNo":
        this.state.userData.contactNo = value;
        break;
        break;
      case "emailId":
        this.state.userData.emailId = value;
        break;
      case "address":
        this.state.userData.address = value;
        break;
      case "city":
        this.state.userData.city = value;
        break;
      case "state":
        this.state.userData.state = value;
        break;
      case "country":
        this.state.userData.country = value;
        break;
    }
    this.setState({ userData: this.state.userData });
  };

  CallRazorPay = async () => {
    // https://dev.to/soumyadey/integrate-razorpay-in-your-react-app-2nib
    // https://razorpay.com/docs/payments/payment-gateway/web-integration/standard/integration-steps/#3-go-live-checklist
    var ordid = "order_" + new Date().getTime();
    var custName = "";
    var emailId = "";
    var mobileNo = "";

    if (this.context.userData.loginStatus === "active") {
      custName = this.state.userData.firstName;
      emailId = this.state.userData.emailId;
      mobileNo = this.state.userData.contactNo;
    }

    var result = await axios.post(
      process.env.REACT_APP_API +
        "sales/CreateRazorpayOrder/" +
        ordid +
        "/" +
        Math.round(this.GetGrandTotal(), 0) * 100
    );
    if (!result) {
      alert("Server error. Please try later");
      return;
    }

    var options = {
      key: this.context.GetEcSettingValueByName("razorpayKey"),
      key_secret: this.context.GetEcSettingValueByName("razorpayKeySecret"),
      // amount: 1 * 100,
      amount: Math.round(this.GetGrandTotal(), 0) * 100,
      currency: this.context.GetEcSettingValueByName("razorpayCurrency"),
      name: this.context.GetEcSettingValueByName("razorpayCompanyName"),
      description: this.context.GetEcSettingValueByName(
        "razorpayCompanyDescription"
      ),
      order_id: result.data.Attributes["id"],
      handler: (response) => {
        this.SuccessRazorPayResponse(ordid, response);
      },
      prefill: {
        name: custName, //customer name
        email: emailId, //customer emailId
        contact: mobileNo, //customer phoneno
      },
      notes: {
        address: this.context.GetEcSettingValueByName("razorpayCompanyAddress"),
      },
      theme: {
        color: this.context.GetEcSettingValueByName("razorpayThemeColor"),
      },
      modal: {
        escape: false,
        ondismiss: () => {
          this.context.UpdateOrderStatus("Dismissed");
        },
      },
    };
    var pay = window.Razorpay(options);
    //var rzp1 = new Razorpay(options);
    //pay.on("payment.failed", function (response) {
    pay.on("payment.failed", (response) => {
      this.FailedInRazorPayResponse(response);
    });
    pay.open();
  };
  FailedInRazorPayResponse = (response) => {
    this.context.UpdateOrderStatus("Failed");
  };
  SuccessRazorPayResponse = (orderId, response) => {
    this.SubmitOrder(orderId, response);
    console.log(response.razorpay_payment_id);
  };

  SubmitOrder = (orderId, response) => {
    var str = "";

    this.ShowLoadSpinner();
    //FREE
    if (this.state.selectedLicenseType == this.context.LicenseType.FREE) {
      str = {
        tenantId: this.state.userData.id,
        orderType: 1, //new product requst
        businessName: this.state.businessName,
        businessShortName: this.state.businessShortName,
        businessCategoryId: this.state.businessCategoryId,
        businessDescription: this.state.businessDescription,
        businessPanNumber: this.state.businessPanNumber,
        businessTaxNumber: this.state.businessTaxNumber,
        address: this.state.address,
        city: this.state.city,
        state: this.state.state,
        country: this.state.country,
        contactNo: this.state.contactNo,
        emailId: this.state.emailId,
        pinCode: this.state.pinCode,

        productName: this.context.selectedProduct.name,
        productDescription: this.context.selectedProduct.description,
        productType: this.context.selectedProduct.productType,
        licenseType: this.state.selectedLicenseType,
        licenseMonths: 1,
        dataRetensionMonths: 0,
        dataRetensionMonthlyCost: 0,
        additionalUserCost: this.context.selectedProduct.additionalUserPrice,

        totalUsers: this.state.totalUsers,
        status: 1, //1 NewOrder 2 InProgress 3 Delivered 4 Cancelled

        enableSeo: this.state.enableSEO,
        transactionCharges:
          this.context.IsECommerceProduct(
            this.context.selectedProduct.productType
          ) == true
            ? "0"
            : "0",
        monthlyCost: 0,
        setupCharges: 0,
        discountPercentage: 0,
        subTotalAmt: 0,
        discountAmount: 0,
        taxPercentage: Number(
          this.context.GetEcSettingValueByName("taxPercentage")
        ),
        taxAmount: 0,
        totalSavings: 0,
        totalAmount: 0,
        grandTotalAmount: 0,
        paidAmt: 0, //todo
        couponCode: "",
        CouponValue: 0,
      };
    } else {
      str = {
        tenantId: this.state.userData.id,
        orderType: 1, //new product requst
        businessName: this.state.businessName,
        businessShortName: this.state.businessShortName,
        businessCategoryId: this.state.businessCategoryId,
        businessDescription: this.state.businessDescription,
        businessPanNumber: this.state.businessPanNumber,
        businessTaxNumber: this.state.businessTaxNumber,
        address: this.state.address,
        city: this.state.city,
        state: this.state.state,
        country: this.state.country,
        contactNo: this.state.contactNo,
        emailId: this.state.emailId,
        pinCode: this.state.pinCode,

        productName: this.context.selectedProduct.name,
        productDescription: this.context.selectedProduct.description,
        productType: this.context.selectedProduct.productType,
        licenseType: this.state.selectedLicenseType,

        monthlyCost: this.context.selectedProduct.monthlyCost,
        licenseMonths: this.state.selectedLicensePeriod,

        dataRetensionMonths: this.state.selectedRetentionMonths,
        dataRetensionMonthlyCost: this.state.selectedRetentionCost,

        totalUsers: this.state.totalUsers,
        additionalUserCost: this.context.selectedProduct.additionalUserPrice,

        setupCharges: this.context.selectedProduct.setupCharges,
        discountPercentage: this.context.selectedProduct.discount,
        enableSeo: this.state.enableSEO,
        transactionCharges: this.state.transactionCharges,

        subTotalAmt: this.GetSubTotal(),
        discountAmount:
          (this.GetSubTotal() * this.context.selectedProduct.discount) / 100,
        taxPercentage: Number(
          this.context.GetEcSettingValueByName("taxPercentage")
        ),
        taxAmount:
          (this.GetTotal() *
            Number(this.context.GetEcSettingValueByName("taxPercentage"))) /
          100,
        totalSavings: this.GetSavingsAmount(),
        totalAmount: this.GetTotal(),
        grandTotalAmount: this.GetGrandTotal(),

        paidAmt: this.GetGrandTotal(), //todo

        paymentModeId: 1, //1 Razorpay --2 Bank Account
        // razorpayOrderId: orderId,
        razorpayOrderId: response.razorpay_order_id,
        razorpayPaymentId: response.razorpay_payment_id,
        razorpaySignature: response.razorpay_signature,
        paymentTransactionId: response.razorpay_payment_id,

        paymentStatusId: 1, //1 Paid 2 Unpaid 3 Partially Paid
        orderDetails: "",
        status: 1, //1 NewOrder 2 InProgress 3 Delivered 4 Cancelled
        couponCode: "", //TODO
        CouponValue: 0, //TODO
      };
    }

    axios
      .post(process.env.REACT_APP_API + "Sales/SubmitOrder", str)
      .then((response) => {
        if (response.status === 200) {
          this.context.storeOrderInformation(response.data);
          // this.SendInvoiceEmail(response.data);
          this.context.UpdateOrderStatus("Success");
          this.HideLoadSpinner();
        } else {
          alert("Order Submit Failed. Please try again!");
          this.context.UpdateOrderStatus("Failed");
          this.HideLoadSpinner();
        }
      })
      .catch((error) => {
        alert("Transaction Failed!", error);
        this.context.UpdateOrderStatus("Failed");
        this.HideLoadSpinner();
      });
  };

  GetTotalUserPrice = () => {
    return (
      (this.state.totalUsers - 1) *
      this.context.selectedProduct.additionalUserPrice
    );
  };
  GetBaseCost = () => {
    if (this.state.selectedLicenseType == this.context.LicenseType.FREE) {
      return 0;
    } else {
      var tot =
        Number(this.context.selectedProduct.monthlyCost) +
        (this.state.totalUsers - 1) *
          this.context.selectedProduct.additionalUserPrice +
        Number(this.state.selectedRetentionCost);
      if (this.state.enableSEO == true) {
        tot += Number(this.context.GetEcSettingValueByName("SeoCost"));
      }
      return tot;
    }
  };

  GetSubTotal = () => {
    var months =
      this.state.selectedLicensePeriod == 12
        ? 11
        : this.state.selectedLicensePeriod == 24
        ? 21
        : this.state.selectedLicensePeriod == 36
        ? 30
        : this.state.selectedLicensePeriod;
    var tot = this.GetBaseCost() * months;

    if (this.context.selectedProduct.setupCharges > 0) {
      tot += this.context.selectedProduct.setupCharges;
    }
    return tot;
  };

  GetTotal = () => {
    var subTotal = this.GetSubTotal();
    return (
      subTotal -
      (subTotal * this.context.selectedProduct.discount) / 100 -
      this.state.CouponValue
    );
  };

  GetGrandTotal = () => {
    return (
      Math.round(this.GetTotal()) +
      Math.round(
        this.GetTotal() *
          Number(this.context.GetEcSettingValueByName("taxPercentage"))
      ) /
        100
    );
  };

  GetSavingsAmount = () => {
    var sav = 0;

    sav += (this.GetSubTotal() * this.context.selectedProduct.discount) / 100;

    if (this.state.selectedLicensePeriod == 12) sav += this.GetBaseCost();
    else if (this.state.selectedLicensePeriod == 24)
      sav += this.GetBaseCost() * 3;
    else if (this.state.selectedLicensePeriod == 36)
      sav += this.GetBaseCost() * 6;

    return sav;
  };

  OnChangeLicenseType = (event) => {
    if (event.target.id === "Free") {
      this.setState({ selectedLicenseType: this.context.LicenseType.FREE });
      this.setState({ totalUsers: 1 });
      this.setState({ selectedRetentionMonths: 12 });
      this.setState({ selectedRetentionCost: 0 });
      this.setState({ enableSEO: false });
    } else if (event.target.id === "Standard") {
      this.setState({ selectedLicenseType: this.context.LicenseType.STANDARD });
      this.setState({ totalUsers: 1 });
      this.setState({ selectedRetentionMonths: 12 });
      this.setState({
        selectedRetentionCost: Number(
          this.context.GetEcSettingValueByName("dataRententionOneYear")
        ),
      });
      this.setState({ enableSEO: false });
    } else if (event.target.id === "Professional") {
      this.setState({
        selectedLicenseType: this.context.LicenseType.PROFESSIONAL,
      });
      this.setState({ totalUsers: 3 });
      this.setState({ selectedRetentionMonths: 24 });
      this.setState({
        selectedRetentionCost: Number(
          this.context.GetEcSettingValueByName("dataRentention2Years")
        ),
      });
      this.setState({ enableSEO: false });
    } else if (event.target.id === "Premium") {
      this.setState({ selectedLicenseType: this.context.LicenseType.PREMIUM });
      this.setState({ totalUsers: 5 });
      this.setState({ selectedRetentionMonths: 36 });
      this.setState({
        selectedRetentionCost: Number(
          this.context.GetEcSettingValueByName("dataRentention3Years")
        ),
      });

      if (
        this.context.IsECommerceProduct(
          this.context.selectedProduct.productType
        )
      ) {
        this.setState({ enableSEO: true });
      } else this.setState({ enableSEO: false });
    } else if (event.target.id === "Custom") {
      this.setState({ selectedLicenseType: this.context.LicenseType.CUSTOM });
      this.setState({ totalUsers: 1 });
      this.setState({ selectedRetentionMonths: 12 });
      this.setState({
        selectedRetentionCost: Number(
          this.context.GetEcSettingValueByName("dataRententionOneYear")
        ),
      });
      this.setState({ enableSEO: false });
    }
  };

  IsStoreNameAvailable = () => {
    if (
      this.state.businessShortName == "" ||
      this.state.businessShortName == undefined
    )
      return;

    fetch(
      process.env.REACT_APP_API +
        "Sales/IsStoreNameAvailable/" +
        this.state.businessShortName
    )
      .then((response) => {
        if (response.status == 200)
          this.setState({ IsStoreShortNameAvailable: true });
        else {
          this.setState({ IsStoreShortNameAvailable: false });

          Swal.fire({
            title: "Information!",
            confirmButtonColor: "#23B14D",
            text: "Business Short-Name is already used. Try a different Name or Please Contact our Support! ",
            confirmButtonText: "Ok",
          }).then((result) => {
            if (result.isConfirmed) {
              this.setState({ businessShortName: "" });
            }
          });
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
        this.setState({ IsStoreShortNameAvailable: true });
      });
  };

  ValidateExtra = () => {
    if (this.state.IsStoreShortNameAvailable === false) {
      Swal.fire({
        title: "Information!",
        confirmButtonColor: "#23B14D",
        text: "Business Shortname is already used. Try a different name or Please Contact our Support! ",
        confirmButtonText: "Ok",
      }).then((result) => {
        if (result.isConfirmed) {
        }
      });
      return false;
    }
    if (this.state.acceptTermsAndConditions != true) {
      Swal.fire({
        title: "Information!",
        confirmButtonColor: "#23B14D",
        text: "Please accept Terms and Conditions and proceed!",
        confirmButtonText: "Ok",
      }).then((result) => {
        if (result.isConfirmed) {
        }
      });
      return false;
    }
  };
  SaveUserData() {
    fetch(process.env.REACT_APP_API + "Sales/UpdateTenant/", {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(this.state.userData),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 404 || data.status == 400) {
          return;
        }
        return;
      })
      .catch((error) => {
        alert("Error on SaveUserData:" + error);
      });
  }

  handleSubmit = (event) => {
    const form = event.currentTarget;
    event.preventDefault();

    if (form.checkValidity() === false || this.ValidateExtra() === false) {
      event.stopPropagation();
      this.setState({ validated: true });
    } else {
      //Save user Details first
      this.SaveUserData();
      if (this.state.selectedLicenseType == this.context.LicenseType.FREE) {
        this.SubmitOrder();
      } else {
        this.CallRazorPay();
      }
      this.setState({ validated: true });
    }
  };

  componentDidMount = () => {
    window.scrollTo(0, 0);
    if (this.context.userData.loginStatus === "active") {
      if (this.state.firstLoad == undefined) {
        this.state.firstLoad = true;
        this.GetUserData();
      }
    }
  };

  render() {
    if (this.context.userData.loginStatus != "active")
      return <Navigate to="/home" />;

    if (this.context.OrderStatus == "Success") {
      return <Navigate to="/CompleteOrder" />;
    }
    return (
      <>
        <div
          class=""
          style={{
            paddingTop: "20px",
            paddingLeft: window.innerWidth > 1200 ? "75px" : "10px",
            paddingRight: window.innerWidth > 1200 ? "75px" : "10px",
            paddingBottom: "200px",
          }}
        >
          <div class="">
            <div class="row gx-2">
              {this.state.loadSpinnerOpen === true ? (
                <LoadSpinner open="true"></LoadSpinner>
              ) : (
                ""
              )}
              <div className="text-center display-6 text-black py-3">
                CHECKOUT
              </div>
              <Form
                noValidate
                validated={this.state.validated}
                onSubmit={this.handleSubmit}
              >
                <Row>
                  <Col md={6}>
                    <div>
                      <h4 className="text-center" style={{ color: "gray" }}>
                        {" "}
                        Billing Address
                      </h4>

                      <div className="border-0 p-3  text-dark bg-light">
                        <Row className="m-0 p-0">
                          <Col className="text-end m-0 p-0">
                            <Button
                              className="border-0 text-primary "
                              as={Link}
                              to="/UserProfile"
                              style={{ backgroundColor: "transparent" }}
                            >
                              <u>Edit Profile</u>
                            </Button>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <b>Name:</b>&nbsp;{" "}
                            {this.state.userData.firstName +
                              " " +
                              this.state.userData.lastName}
                          </Col>
                        </Row>
                        <b>Address:</b>&nbsp;
                        {this.state.userData.address + ", "}
                        {this.state.userData.city +
                          ", " +
                          this.state.userData.state +
                          ", " +
                          this.state.userData.country +
                          " - " +
                          this.state.userData.pinCode}
                        <br />
                        <b>Contact Number:</b>&nbsp;{" "}
                        {this.state.userData.contactNo}
                        <br />
                        <b>Email Id:</b>&nbsp; {this.state.userData.emailId}
                      </div>
                    </div>
                    <div>
                      <h4
                        className="text-center pt-5"
                        style={{ color: "gray" }}
                      >
                        {" "}
                        Business Details
                      </h4>
                      <div
                        className="border-0 p-3  text-dark bg-light"
                        style={{
                          fontSize: "18px",
                        }}
                      >
                        <Row>
                          <Form.Group
                            as={Col}
                            md="6"
                            controlId="validationCustom01"
                          >
                            <FloatingLabel
                              controlId="floatingInput"
                              label="Enter Business Full Name *"
                              className="mb-3  "
                            >
                              <Form.Control
                                type="text"
                                name="businessName"
                                className="bg-white"
                                size="lg"
                                // maxLength={20}
                                required
                                value={this.state.businessName}
                                onChange={(e) =>
                                  this.setState({
                                    businessName: e.target.value,
                                  })
                                }
                              />
                              <Form.Control.Feedback type="invalid">
                                Please enter Business Name
                              </Form.Control.Feedback>
                            </FloatingLabel>
                          </Form.Group>

                          <Form.Group
                            as={Col}
                            md="6"
                            controlId="validationCustom01"
                          >
                            <FloatingLabel
                              controlId="floatingInput"
                              label="Business Short-Name *"
                              className="mb-3"
                            >
                              <Form.Control
                                type="text"
                                name="businessShortName"
                                className="bg-white"
                                size="lg"
                                maxLength={24}
                                required
                                value={this.state.businessShortName}
                                onBlur={(e) => this.IsStoreNameAvailable()}
                                onChange={(e) => {
                                  var pattern = new RegExp(/^[a-zA-Z0-9 ]*$/);
                                  if (pattern.test(e.target.value) == true) {
                                    this.setState({
                                      businessShortName: e.target.value.replace(
                                        /\s/g,

                                        ""
                                      ),
                                    });
                                  }
                                }}
                              />
                              <Form.Control.Feedback type="invalid">
                                Please enter Business Name
                              </Form.Control.Feedback>
                            </FloatingLabel>
                          </Form.Group>
                        </Row>
                        <Row>
                          <Form.Group as={Col} md="6">
                            <FloatingLabel
                              controlId="floatingInput"
                              label="Email ID *"
                              className="mb-3"
                            >
                              <Form.Control
                                name="emailId"
                                type="email"
                                required
                                value={this.state.emailId}
                                onChange={(e) =>
                                  this.setState({
                                    emailId: e.target.value,
                                  })
                                }
                              />
                              <Form.Control.Feedback type="invalid">
                                Please a valid Email Id
                              </Form.Control.Feedback>
                            </FloatingLabel>
                          </Form.Group>
                          <Form.Group as={Col} md="6">
                            <FloatingLabel
                              controlId="floatingInput"
                              label="Contact Number *"
                              className="mb-3"
                            >
                              <Form.Control
                                name="contactNo"
                                type="text"
                                required
                                value={this.state.contactNo}
                                onChange={(e) =>
                                  this.setState({
                                    contactNo: e.target.value,
                                  })
                                }
                              />
                              <Form.Control.Feedback type="invalid">
                                Please a valid Contact Number
                              </Form.Control.Feedback>
                            </FloatingLabel>
                          </Form.Group>
                        </Row>
                        <Row>
                          <Col>
                            <Form.Group controlId="validationCustom01">
                              <FloatingLabel
                                controlId="floatingInput"
                                label="Select Business Type *"
                                className="mb-3  "
                              >
                                <Form.Select
                                  type="text"
                                  name="businessCategoryId"
                                  className="bg-white"
                                  required
                                  value={this.state.businessCategoryId}
                                  onChange={(e) =>
                                    this.setState({
                                      businessCategoryId: e.target.value,
                                    })
                                  }
                                >
                                  <option value=""></option>
                                  {this.context.businessCategories.map((m) => (
                                    <>
                                      <option value={m.id}>{m.name}</option>
                                    </>
                                  ))}
                                </Form.Select>
                                <Form.Control.Feedback type="invalid">
                                  Please enter your Business Type
                                </Form.Control.Feedback>
                              </FloatingLabel>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Form.Group as={Col} md="12">
                            <Form.Control
                              as="textarea"
                              type="textarea"
                              rows={3}
                              name="businessDescription"
                              placeholder="Business Summary *"
                              required
                              className="bg-white"
                              value={this.state.businessDescription}
                              onChange={(e) =>
                                this.setState({
                                  businessDescription: e.target.value,
                                })
                              }
                            />
                          </Form.Group>
                        </Row>
                        <Row>
                          <Form.Group as={Col} md="6">
                            <FloatingLabel
                              controlId="floatingInput"
                              label="Business ID/PAN Number *"
                              className="mb-3  "
                            >
                              <Form.Control
                                type="text"
                                name="businessPanNumber"
                                required
                                className="bg-white"
                                value={this.state.businessPanNumber}
                                onChange={(e) =>
                                  this.setState({
                                    businessPanNumber: e.target.value,
                                  })
                                }
                              />
                              <Form.Control.Feedback type="invalid">
                                Please enter Business ID/PAN Number.
                              </Form.Control.Feedback>
                            </FloatingLabel>
                          </Form.Group>
                          <Form.Group as={Col} md="6">
                            <FloatingLabel
                              controlId="floatingInput"
                              label="Tax/GST Number *"
                              className="mb-3  "
                            >
                              <Form.Control
                                type="text"
                                name="businessTaxNumber"
                                required
                                className="bg-white"
                                value={this.state.businessTaxNumber}
                                onChange={(e) =>
                                  this.setState({
                                    businessTaxNumber: e.target.value,
                                  })
                                }
                              />
                              <Form.Control.Feedback type="invalid">
                                Please enter a valid Tax/GST Number.
                              </Form.Control.Feedback>
                            </FloatingLabel>
                          </Form.Group>
                        </Row>
                        <Row>
                          <Col sm={8}>
                            <Form.Group controlId="validationCustom07">
                              <FloatingLabel
                                controlId="floatingInput"
                                label="Full Address *"
                                className="mb-3 moveLabelUp "
                              >
                                <Form.Control
                                  type="text"
                                  name="address"
                                  size="lg"
                                  required
                                  value={this.state.address}
                                  onChange={(e) =>
                                    this.setState({ address: e.target.value })
                                  }
                                />
                                <Form.Control.Feedback type="invalid">
                                  Please enter address
                                </Form.Control.Feedback>
                              </FloatingLabel>
                            </Form.Group>
                          </Col>
                          <Col sm={4}>
                            <Form.Group controlId="validationCustom07">
                              <FloatingLabel
                                controlId="floatingInput"
                                label="City *"
                                className="mb-3 moveLabelUp "
                              >
                                <Form.Control
                                  type="text"
                                  name="city"
                                  size="lg"
                                  required
                                  value={this.state.city}
                                  onChange={(e) =>
                                    this.setState({ city: e.target.value })
                                  }
                                />
                                <Form.Control.Feedback type="invalid">
                                  Please enter City
                                </Form.Control.Feedback>
                              </FloatingLabel>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row>
                          <Form.Group as={Col} md="4">
                            <FloatingLabel
                              controlId="floatingInput"
                              label="Country *"
                              className="mb-3  "
                            >
                              <Form.Select
                                value={this.state.country}
                                name="country"
                                required
                                onChange={(e) =>
                                  this.setState({ country: e.target.value })
                                }
                              >
                                <option value=""></option>
                                {Country.getAllCountries().map((country) => (
                                  <>
                                    <option value={country.isoCode}>
                                      {country.name}
                                    </option>
                                  </>
                                ))}
                              </Form.Select>
                              <Form.Control.Feedback type="invalid">
                                Please select country
                              </Form.Control.Feedback>
                            </FloatingLabel>
                          </Form.Group>

                          <Form.Group
                            as={Col}
                            md="4"
                            controlId="validationCustom10"
                          >
                            <FloatingLabel
                              controlId="floatingInput"
                              label="State *"
                              className="mb-3  "
                            >
                              <Form.Select
                                value={this.state.state}
                                name="state"
                                required
                                onChange={(e) =>
                                  this.setState({ state: e.target.value })
                                }
                              >
                                <option value=""></option>
                                {State.getStatesOfCountry(
                                  this.state.country
                                ).map((s1) => (
                                  <>
                                    <option>{s1.name}</option>
                                  </>
                                ))}
                              </Form.Select>
                              <Form.Control.Feedback type="invalid">
                                Please select State
                              </Form.Control.Feedback>
                            </FloatingLabel>
                          </Form.Group>

                          <Form.Group
                            as={Col}
                            md="4"
                            controlId="validationCustom07"
                          >
                            <FloatingLabel
                              controlId="floatingInput"
                              label="PinCode *"
                              className="mb-3 moveLabelUp "
                            >
                              <Form.Control
                                type="text"
                                name="pinCode"
                                size="lg"
                                required
                                value={this.state.pinCode}
                                onChange={(e) =>
                                  this.setState({ pinCode: e.target.value })
                                }
                              />
                              <Form.Control.Feedback type="invalid">
                                Please enter PinCode
                              </Form.Control.Feedback>
                            </FloatingLabel>
                          </Form.Group>
                        </Row>
                      </div>
                    </div>
                  </Col>

                  <Col md={6}>
                    <h4 className="text-center" style={{ color: "gray" }}>
                      {" "}
                      Order Summary
                    </h4>
                    <div
                      className="border-0 p-3  text-dark bg-light"
                      style={{
                        fontSize: "14px",
                      }}
                    >
                      <Row>
                        <Col md={4}>
                          <h5 className="text-muted">Product Name:</h5>
                        </Col>{" "}
                        <Col md={8}>
                          <h5 className="text-primary bg-white">
                            {this.context.selectedProduct.name}
                          </h5>
                        </Col>
                      </Row>
                      <hr />
                      <h5
                        style={{ color: "black" }}
                        className={
                          this.state.selectedLicenseType === ""
                            ? "blink_me"
                            : ""
                        }
                      >
                        Select License Plan
                      </h5>
                      <Row className="border bg-info m-1 py-2 text-center">
                        {[
                          {
                            id: "Free",
                            label: "Free Trial",
                            type: this.context.LicenseType.FREE,
                          },
                          {
                            id: "Standard",
                            label: "Standard",
                            type: this.context.LicenseType.STANDARD,
                          },
                          {
                            id: "Professional",
                            label: "Professional",
                            type: this.context.LicenseType.PROFESSIONAL,
                          },
                          {
                            id: "Premium",
                            label: "Premium",
                            type: this.context.LicenseType.PREMIUM,
                          },
                          {
                            id: "Custom",
                            label: "Custom",
                            type: this.context.LicenseType.CUSTOM,
                          },
                        ].map((license, idx) => (
                          <>
                            <Col
                              key={idx}
                              xs={6}
                              sm={4}
                              md={4}
                              className="d-flex justify-content-start mb-2 mb-md-0"
                            >
                              <Form.Check
                                type="radio"
                                name="licensetype"
                                id={license.id}
                                className="text-white fw-bold"
                                style={{ fontSize: "18px" }}
                                checked={
                                  this.state.selectedLicenseType ===
                                  license.type
                                }
                                label={license.label}
                                onChange={(e) => this.OnChangeLicenseType(e)}
                              />
                            </Col>
                            {/* {(license.type == this.context.LicenseType.FREE &&
                              (this.context.selectedProduct.productType ==
                                this.context.ProductType.Retail_ERP ||
                                this.context.selectedProduct.productType ==
                                  this.context.ProductType.Restaurant_ERP ||
                                this.context.selectedProduct.productType ==
                                  this.context.ProductType.ERP ||
                                this.context.selectedProduct.productType ==
                                  this.context.ProductType.SupplyChain ||
                                this.context.selectedProduct.productType ==
                                  this.context.ProductType.WebSite)) ||
                            (license.type == this.context.LicenseType.CUSTOM &&
                              this.context.selectedProduct.productType ==
                                this.context.ProductType.WebSite) ? (
                              <></>
                            ) : (
                              <>
                                
                              </>
                            )} */}
                          </>
                        ))}
                      </Row>

                      <Form.Group as={Row} className="mb-1">
                        <Form.Label
                          column
                          xd="6"
                          className="text-start"
                        ></Form.Label>

                        <Col sm="4"></Col>
                      </Form.Group>
                      {/* Free */}
                      {this.state.selectedLicenseType ===
                      this.context.LicenseType.FREE ? ( //Free
                        <>
                          {/* <Form.Group as={Row} className="mb-1">
                            <Col xd="6" className="border-0 border-dark">
                              <Form.Label type="number" className="text-start">
                                <h6 className="text-muted">
                                  Total User Access{" "}
                                </h6>
                                <span style={{ fontWeight: "normal" }}>
                                  (Admin/Contributor)
                                </span>
                              </Form.Label>
                            </Col>
                            <Col
                              xd="6"
                              className="border-0 border-dark text-center"
                            >
                              <h5>1</h5>
                            </Col>
                          </Form.Group>
                          <Form.Group
                            as={Row}
                            className="mb-1"
                            controlId="formPlaintextEmail"
                          >
                            <Form.Label column xd="6" className="text-start">
                              <h6 className="text-muted">Total Products</h6>
                            </Form.Label>
                            <Col xd="6" className="text-center">
                              <h5>Unlimited</h5>
                            </Col>
                          </Form.Group>
                          <Form.Group
                            as={Row}
                            className="mb-1"
                            controlId="formPlaintextEmail"
                          >
                            <Form.Label column xd="6" className="text-start">
                              <h6 className="text-muted">Total Transaction</h6>
                            </Form.Label>
                            <Col xd="6" className="text-center">
                              <h5>Unlimited</h5>
                            </Col>
                          </Form.Group>

                          <Form.Group
                            as={Row}
                            className="mb-1"
                            controlId="formPlaintextEmail"
                          >
                            <Form.Label column xd="6" className="text-start">
                              <h6 className="text-muted">
                                Transaction Data Retention
                              </h6>
                            </Form.Label>
                            <Col xd="6" className="text-center">
                              <h5>
                                {Number(
                                  this.context.GetEcSettingValueByName(
                                    "dataRententionFreeDays"
                                  )
                                )}{" "}
                                Days
                              </h5>
                            </Col>
                          </Form.Group> */}

                          <Form.Group
                            as={Row}
                            className="mb-1"
                            controlId="formPlaintextEmail"
                          >
                            <Form.Label column xd="6" className="text-start">
                              <h6 className="text-muted">License Period</h6>
                            </Form.Label>
                            <Col xd="6" className="text-center">
                              <h5>30 Days</h5>
                            </Col>
                          </Form.Group>
                          {/* {this.context.IsECommerceProduct(
                            this.context.selectedProduct.productType
                          ) ? (
                            <>
                              <Form.Group
                                as={Row}
                                className="mb-1"
                                controlId="formPlaintextEmail"
                              >
                                <Form.Label
                                  column
                                  xd="6"
                                  className="text-start"
                                >
                                  <b>Setting up Online Store </b>
                                </Form.Label>
                                <Form.Label
                                  column
                                  xd="6"
                                  className="text-start bg-white CornersRoundedSmall p-2"
                                >
                                  <b>Self.</b>
                                  <br /> [Note: If require a service to setup
                                  your Online Store, we will get a quote based
                                  on your requirement]
                                </Form.Label>
                              </Form.Group>
                              <Form.Group
                                as={Row}
                                className="mb-1"
                                controlId="formPlaintextEmail"
                              >
                                <Form.Label
                                  column
                                  xd="6"
                                  className="text-start"
                                >
                                  <b>Total Products </b>
                                </Form.Label>
                                <Form.Label
                                  column
                                  xd="6"
                                  className="text-start bg-white CornersRoundedSmall p-2"
                                >
                                  <b>Unlimited</b>
                                </Form.Label>
                              </Form.Group>
                              <Form.Group
                                as={Row}
                                className="mb-1"
                                controlId="formPlaintextEmail"
                              >
                                <Form.Label
                                  column
                                  xd="6"
                                  className="text-start"
                                >
                                  <b>Total Transactions </b>
                                </Form.Label>
                                <Form.Label
                                  column
                                  xd="6"
                                  className="text-start bg-white CornersRoundedSmall p-2"
                                >
                                  <b>Unlimited</b>
                                </Form.Label>
                              </Form.Group>
                              <Form.Group as={Row} className="mb-1">
                                <Form.Label
                                  column
                                  xd="6"
                                  type="number"
                                  className="text-start"
                                >
                                  <h6 className="">SEO & Self Hosting</h6>{" "}
                                </Form.Label>

                                <Form.Label
                                  column
                                  xd="6"
                                  className="text-start bg-white CornersRoundedSmall p-2"
                                >
                                  <b>Disabled</b>
                                </Form.Label>
                              </Form.Group>
                              <Form.Group
                                as={Row}
                                className="mb-1"
                                controlId="formPlaintextEmail"
                              >
                                <Form.Label
                                  column
                                  xd="6"
                                  className="text-start"
                                >
                                  <b>Transaction Fee </b>
                                  <br />
                                  [Only from on Online Sale]
                                </Form.Label>
                                <Form.Label
                                  column
                                  xd="6"
                                  className="text-start bg-white CornersRoundedSmall p-2"
                                >
                                  <b style={{ fontSize: "18px", color: "red" }}>
                                    4.8% on Online Sale.
                                  </b>
                                  &nbsp; [This will be billed end of every
                                  month]
                                </Form.Label>
                              </Form.Group>
                            </>
                          ) : (
                            <>
                              
                            </>
                          )} */}

                          <hr />
                          <Row className="border-0 my-3 mx-3 w-100">
                            <Col
                              sm={12}
                              className="text-center border-0"
                              style={{
                                verticalAlign: "middle",
                                alignItems: "center",
                                display: "flex",
                                fontSize: "16px",
                              }}
                            >
                              <Row className="w-100">
                                <Col sm={12} className="text-start border-0">
                                  <Stack direction="horizontal">
                                    <Form.Check
                                      checked={
                                        this.state.acceptTermsAndConditions
                                      }
                                      label="by selecting, I agree to the "
                                      onChange={(e) =>
                                        this.setState({
                                          acceptTermsAndConditions:
                                            e.target.checked,
                                        })
                                      }
                                    />
                                    <Nav.Link
                                      as={Link}
                                      to="/TermsAndConditions"
                                      className=""
                                      target="_blank"
                                    >
                                      <u>Terms & Conditions</u>
                                    </Nav.Link>
                                  </Stack>
                                </Col>
                              </Row>
                            </Col>
                          </Row>

                          <Form.Group className="text-center">
                            <Button
                              type="submit"
                              column
                              sm="12"
                              variant="warning"
                              size="lg"
                            >
                              Proceed
                            </Button>
                          </Form.Group>
                        </>
                      ) : (
                        <></>
                      )}
                      {/* Other Plans */}
                      {this.state.selectedLicenseType ==
                        this.context.LicenseType.STANDARD ||
                      this.state.selectedLicenseType ==
                        this.context.LicenseType.PROFESSIONAL ||
                      this.state.selectedLicenseType ==
                        this.context.LicenseType.PREMIUM ||
                      this.state.selectedLicenseType ==
                        this.context.LicenseType.CUSTOM ? (
                        <>
                          <Form.Group as={Row} className="mb-1">
                            <Form.Label
                              column
                              xd={window.innerWidth > 1200 ? "5" : "6"}
                              type="number"
                              className="text-start"
                            >
                              <h6 className="text-muted"> Base Cost </h6>
                            </Form.Label>
                            {window.innerWidth > 1200 ? (
                              <>
                                <Col xd="3"></Col>
                              </>
                            ) : (
                              <></>
                            )}
                            <Col
                              xd={window.innerWidth > 1200 ? "4" : "6"}
                              className="verticalaligncentertd"
                            >
                              <h6>
                                {this.state.selectedLicenseType ==
                                this.context.LicenseType.CUSTOM ? (
                                  <>
                                    {this.context.selectedProduct.monthlyCost.toLocaleString(
                                      "en-IN",
                                      {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 0,
                                        style: "currency",
                                        currency: "INR",
                                      }
                                    )}{" "}
                                    / Month
                                  </>
                                ) : (
                                  <>
                                    {this.GetBaseCost().toLocaleString(
                                      "en-IN",
                                      {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 0,
                                        style: "currency",
                                        currency: "INR",
                                      }
                                    )}{" "}
                                    / Month
                                  </>
                                )}
                              </h6>
                            </Col>
                          </Form.Group>

                          {this.context.selectedProduct.productType !=
                            this.context.ProductType.WebSite &&
                          (this.state.selectedLicenseType ==
                            this.context.LicenseType.STANDARD ||
                            this.state.selectedLicenseType ==
                              this.context.LicenseType.PROFESSIONAL ||
                            this.state.selectedLicenseType ==
                              this.context.LicenseType.PREMIUM) ? (
                            <>
                              <Form.Group as={Row} className="mb-1">
                                <Form.Label
                                  column
                                  xd={window.innerWidth > 1200 ? "4" : "6"}
                                  type="number"
                                  className="text-start"
                                >
                                  <h6 className="text-muted">
                                    Total "User Access" (Admin/Contributor)
                                  </h6>{" "}
                                </Form.Label>
                                {window.innerWidth > 1200 ? (
                                  <>
                                    <Col sm="4"></Col>
                                  </>
                                ) : (
                                  <></>
                                )}

                                <Form.Label
                                  column
                                  xd={window.innerWidth > 1200 ? "4" : "6"}
                                  className="verticalaligncentertd"
                                >
                                  <h6>{this.state.totalUsers}</h6>
                                </Form.Label>
                              </Form.Group>

                              <Form.Group as={Row} className="mb-1">
                                <Form.Label
                                  column
                                  xd={window.innerWidth > 1200 ? "4" : "6"}
                                  type="number"
                                  className="text-start"
                                >
                                  <h6 className="text-muted">
                                    Transaction Data Retention
                                  </h6>{" "}
                                </Form.Label>
                                {window.innerWidth > 1200 ? (
                                  <>
                                    <Col xd="4"></Col>
                                  </>
                                ) : (
                                  <></>
                                )}
                                <Form.Label
                                  column
                                  xd={window.innerWidth > 1200 ? "4" : "6"}
                                  className="verticalaligncentertd"
                                >
                                  <h6>
                                    {this.state.selectedRetentionMonths} Months
                                  </h6>
                                </Form.Label>
                              </Form.Group>
                              {this.context.IsECommerceProduct(
                                this.context.selectedProduct.productType
                              ) ? (
                                <>
                                  <Form.Group as={Row} className="mb-1">
                                    <Form.Label
                                      column
                                      xd={window.innerWidth > 1200 ? "4" : "6"}
                                      type="number"
                                      className="text-start"
                                    >
                                      <h6 className="text-muted">
                                        SEO & Self Hosting
                                      </h6>{" "}
                                      <br />
                                    </Form.Label>
                                    {window.innerWidth > 1200 ? (
                                      <>
                                        <Col xd="4"></Col>
                                      </>
                                    ) : (
                                      <></>
                                    )}
                                    <Form.Label
                                      column
                                      xd={window.innerWidth > 1200 ? "4" : "6"}
                                      className="verticalaligncentertd"
                                    >
                                      <h6>
                                        {this.state.enableSEO == true
                                          ? "ENABLED"
                                          : "DISABLED"}
                                      </h6>
                                    </Form.Label>
                                  </Form.Group>
                                </>
                              ) : (
                                <></>
                              )}
                            </>
                          ) : (
                            <></>
                          )}
                          {this.state.selectedLicenseType ==
                          this.context.LicenseType.CUSTOM ? (
                            <>
                              <Form.Group as={Row} className="mb-1">
                                <Form.Label
                                  column
                                  xd={window.innerWidth > 1200 ? "4" : "6"}
                                  type="number"
                                  className="text-start"
                                >
                                  <h6 className="text-muted">
                                    Select total "User Access" required
                                    (Admin/Contributor)
                                  </h6>{" "}
                                  <br />
                                </Form.Label>
                                {window.innerWidth > 1200 ? (
                                  <>
                                    <Col
                                      xd="4"
                                      className="verticalaligncentertd"
                                    >
                                      <div className="px-3">
                                        <IncDecCounter
                                          intvalue={this.state.totalUsers}
                                          valueChangeCallback={(e) => {
                                            if (e > 0) {
                                              this.setState({
                                                totalUsers: e,
                                              });
                                            } else {
                                              this.setState({
                                                totalUsers:
                                                  this.state.totalUsers,
                                              });
                                            }
                                          }}
                                        ></IncDecCounter>
                                      </div>
                                    </Col>
                                  </>
                                ) : (
                                  <></>
                                )}

                                <Form.Label
                                  column
                                  xd={window.innerWidth > 1200 ? "4" : "6"}
                                  className={
                                    window.innerWidth > 1200
                                      ? "verticalaligncentertd"
                                      : "text-center"
                                  }
                                >
                                  {window.innerWidth > 1200 ? (
                                    <></>
                                  ) : (
                                    <>
                                      <div className="px-0">
                                        <IncDecCounter
                                          intvalue={this.state.totalUsers}
                                          valueChangeCallback={(e) => {
                                            if (e > 0) {
                                              this.setState({
                                                totalUsers: e,
                                              });
                                            } else {
                                              this.setState({
                                                totalUsers:
                                                  this.state.totalUsers,
                                              });
                                            }
                                          }}
                                        ></IncDecCounter>
                                      </div>
                                      <br />
                                    </>
                                  )}

                                  <h6>
                                    {this.GetTotalUserPrice().toLocaleString(
                                      "en-IN",
                                      {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 0,
                                        style: "currency",
                                        currency: "INR",
                                      }
                                    )}{" "}
                                    / Month
                                  </h6>
                                </Form.Label>
                              </Form.Group>

                              <Form.Group
                                as={Row}
                                className="mb-1"
                                controlId="formPlaintextEmail"
                              >
                                <Form.Label
                                  column
                                  xd={window.innerWidth > 1200 ? "4" : "6"}
                                  className="text-start"
                                >
                                  <h6 className="text-muted">
                                    Transaction Data Retention
                                  </h6>
                                </Form.Label>
                                {window.innerWidth > 1200 ? (
                                  <>
                                    <Col sm="4">
                                      <Form.Select
                                        className="border text-center fw-bold"
                                        plaintext
                                        name="selectedRetentionMonths"
                                        value={
                                          this.state.selectedRetentionMonths
                                        }
                                        onChange={(e) => {
                                          this.setState({
                                            selectedRetentionMonths:
                                              e.target.value,
                                          });
                                          if (e.target.value == 3) {
                                            this.setState({
                                              selectedRetentionCost: 0,
                                            });
                                          }
                                          if (e.target.value == 12) {
                                            this.setState({
                                              selectedRetentionCost: Number(
                                                this.context.GetEcSettingValueByName(
                                                  "dataRententionOneYear"
                                                )
                                              ),
                                            });
                                          }
                                          if (e.target.value == 24) {
                                            this.setState({
                                              selectedRetentionCost: Number(
                                                this.context.GetEcSettingValueByName(
                                                  "dataRentention2Years"
                                                )
                                              ),
                                            });
                                          }
                                          if (e.target.value == 36) {
                                            this.setState({
                                              selectedRetentionCost: Number(
                                                this.context.GetEcSettingValueByName(
                                                  "dataRentention3Years"
                                                )
                                              ),
                                            });
                                          }
                                          if (e.target.value == 60) {
                                            this.setState({
                                              selectedRetentionCost: Number(
                                                this.context.GetEcSettingValueByName(
                                                  "dataRentention5Years"
                                                )
                                              ),
                                            });
                                          }
                                        }}
                                      >
                                        <option value={3}>
                                          3 Months Retention(Free)
                                        </option>
                                        <option value={12}>
                                          1 Year Retention (
                                          {Number(
                                            this.context.GetEcSettingValueByName(
                                              "dataRententionOneYear"
                                            )
                                          )}{" "}
                                          Per month)
                                        </option>
                                        <option value={24}>
                                          2 Years Retention (
                                          {Number(
                                            this.context.GetEcSettingValueByName(
                                              "dataRentention2Years"
                                            )
                                          )}{" "}
                                          Per month)
                                        </option>
                                        <option value={36}>
                                          3 Years Retention(
                                          {Number(
                                            this.context.GetEcSettingValueByName(
                                              "dataRentention3Years"
                                            )
                                          )}{" "}
                                          Per month)
                                        </option>
                                        <option value={60}>
                                          5 Years Retention(
                                          {Number(
                                            this.context.GetEcSettingValueByName(
                                              "dataRentention5Years"
                                            )
                                          )}{" "}
                                          Per month)
                                        </option>
                                      </Form.Select>
                                    </Col>
                                  </>
                                ) : (
                                  <></>
                                )}

                                <Form.Label
                                  column
                                  xd={window.innerWidth > 1200 ? "4" : "6"}
                                  className="text-center"
                                >
                                  {window.innerWidth > 1200 ? (
                                    <></>
                                  ) : (
                                    <>
                                      <Col sm="4">
                                        <Form.Select
                                          className="border text-center fw-bold"
                                          plaintext
                                          name="selectedRetentionMonths"
                                          value={
                                            this.state.selectedRetentionMonths
                                          }
                                          onChange={(e) => {
                                            this.setState({
                                              selectedRetentionMonths:
                                                e.target.value,
                                            });
                                            if (e.target.value == 3) {
                                              this.setState({
                                                selectedRetentionCost: 0,
                                              });
                                            }
                                            if (e.target.value == 12) {
                                              this.setState({
                                                selectedRetentionCost: Number(
                                                  this.context.GetEcSettingValueByName(
                                                    "dataRententionOneYear"
                                                  )
                                                ),
                                              });
                                            }
                                            if (e.target.value == 24) {
                                              this.setState({
                                                selectedRetentionCost: Number(
                                                  this.context.GetEcSettingValueByName(
                                                    "dataRentention2Years"
                                                  )
                                                ),
                                              });
                                            }
                                            if (e.target.value == 36) {
                                              this.setState({
                                                selectedRetentionCost: Number(
                                                  this.context.GetEcSettingValueByName(
                                                    "dataRentention3Years"
                                                  )
                                                ),
                                              });
                                            }
                                            if (e.target.value == 60) {
                                              this.setState({
                                                selectedRetentionCost: Number(
                                                  this.context.GetEcSettingValueByName(
                                                    "dataRentention5Years"
                                                  )
                                                ),
                                              });
                                            }
                                          }}
                                        >
                                          <option value={3}>
                                            3 Months Retention(Free)
                                          </option>
                                          <option value={12}>
                                            1 Year Retention ( Number(
                                            {this.context.GetEcSettingValueByName(
                                              "dataRententionOneYear"
                                            )}{" "}
                                            Per month)
                                          </option>
                                          <option value={24}>
                                            2 Years Retention (
                                            {Number(
                                              this.context.GetEcSettingValueByName(
                                                "dataRentention2Years"
                                              )
                                            )}{" "}
                                            Per month)
                                          </option>
                                          <option value={36}>
                                            3 Years Retention(
                                            {Number(
                                              this.context.GetEcSettingValueByName(
                                                "dataRentention3Years"
                                              )
                                            )}{" "}
                                            Per month)
                                          </option>
                                          <option value={60}>
                                            5 Years Retention(
                                            {Number(
                                              this.context.GetEcSettingValueByName(
                                                "dataRentention5Years"
                                              )
                                            )}{" "}
                                            Per month)
                                          </option>
                                        </Form.Select>
                                      </Col>
                                    </>
                                  )}
                                  <h6>
                                    {this.state.selectedRetentionCost.toLocaleString(
                                      "en-IN",
                                      {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 0,
                                        style: "currency",
                                        currency: "INR",
                                      }
                                    )}{" "}
                                    / Month
                                  </h6>
                                </Form.Label>
                              </Form.Group>
                              {this.context.IsECommerceProduct(
                                this.context.selectedProduct.productType
                              ) ? (
                                <>
                                  <Form.Group
                                    as={Row}
                                    className="mb-1"
                                    controlId="formPlaintextEmail"
                                  >
                                    <Form.Label
                                      column
                                      xd={window.innerWidth > 1200 ? "4" : "6"}
                                      className="text-start"
                                    >
                                      <h6 className="text-muted">
                                        Enable SEO & Independent Hosting for
                                        ECommerce site
                                      </h6>
                                    </Form.Label>

                                    {window.innerWidth > 1200 ? (
                                      <>
                                        <Col
                                          xd="4"
                                          className="verticalaligncentertd"
                                        >
                                          <Form.Check
                                            style={{ fontSize: "32px" }}
                                            className="fw-bold pt-2"
                                            // label="Select"
                                            checked={this.state.enableSEO}
                                            onChange={(e) =>
                                              this.setState({
                                                enableSEO: e.target.checked,
                                              })
                                            }
                                          ></Form.Check>
                                        </Col>
                                      </>
                                    ) : (
                                      <></>
                                    )}

                                    <Col
                                      xd={window.innerWidth > 1200 ? "4" : "6"}
                                      className={
                                        window.innerWidth > 1200
                                          ? "verticalaligncentertd"
                                          : "text-center"
                                      }
                                    >
                                      {window.innerWidth > 1200 ? (
                                        <></>
                                      ) : (
                                        <>
                                          <Form.Check
                                            style={{ fontSize: "32px" }}
                                            className="fw-bold pt-2"
                                            // label="Select"
                                            checked={this.state.enableSEO}
                                            onChange={(e) =>
                                              this.setState({
                                                enableSEO: e.target.checked,
                                              })
                                            }
                                          ></Form.Check>
                                        </>
                                      )}
                                      <h6>
                                        {this.state.enableSEO == true
                                          ? Number(
                                              this.context.GetEcSettingValueByName(
                                                "SeoCost"
                                              )
                                            ).toLocaleString("en-IN", {
                                              minimumFractionDigits: 0,
                                              maximumFractionDigits: 0,
                                              style: "currency",
                                              currency: "INR",
                                            })
                                          : Number("0").toLocaleString(
                                              "en-IN",
                                              {
                                                minimumFractionDigits: 0,
                                                maximumFractionDigits: 0,
                                                style: "currency",
                                                currency: "INR",
                                              }
                                            )}{" "}
                                        / Month
                                      </h6>
                                    </Col>
                                  </Form.Group>
                                </>
                              ) : (
                                <></>
                              )}
                            </>
                          ) : (
                            <></>
                          )}

                          {this.context.IsECommerceProduct(
                            this.context.selectedProduct.productType
                          ) ||
                          this.context.selectedProduct.productType ==
                            this.context.ProductType.WebSite ? (
                            <>
                              {this.context.selectedProduct.productType ==
                              this.context.ProductType.WebSite ? (
                                <>
                                  <Form.Group
                                    as={Row}
                                    className="mb-2"
                                    controlId="formPlaintextEmail"
                                  >
                                    <Form.Label
                                      column
                                      xd={window.innerWidth > 1200 ? "4" : "6"}
                                      className="text-start"
                                    >
                                      <h6 className="text-muted m-0">
                                        Website Setup Cost(One time)
                                      </h6>
                                    </Form.Label>
                                    {window.innerWidth > 1200 ? (
                                      <>
                                        <Col sm={4}></Col>
                                      </>
                                    ) : (
                                      <></>
                                    )}
                                    <Col
                                      xd={window.innerWidth > 1200 ? "4" : "6"}
                                      className="text-center "
                                    >
                                      <h6>
                                        {this.context.selectedProduct.setupCharges.toLocaleString(
                                          "en-IN",
                                          {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 0,
                                            style: "currency",
                                            currency: "INR",
                                          }
                                        )}
                                        <br></br>
                                        <small>(One time Cost)</small>
                                      </h6>
                                    </Col>
                                  </Form.Group>
                                </>
                              ) : (
                                <>
                                  <Form.Group
                                    as={Row}
                                    className="mb-2"
                                    controlId="formPlaintextEmail"
                                  >
                                    <Form.Label
                                      column
                                      xd={window.innerWidth > 1200 ? "4" : "6"}
                                      className="text-start"
                                    >
                                      <h6 className="text-muted m-0">
                                        ECommerce site Setup Cost(One time)
                                      </h6>
                                      <i className="text-muted ">
                                        &nbsp;[Includes of Setup upto 50
                                        Products. Additional product setup will
                                        be done on demand]
                                      </i>
                                    </Form.Label>
                                    {window.innerWidth > 1200 ? (
                                      <>
                                        <Col sm={4}></Col>
                                      </>
                                    ) : (
                                      <></>
                                    )}
                                    <Col
                                      xd={window.innerWidth > 1200 ? "4" : "6"}
                                      className="text-center verticalaligncentertd"
                                    >
                                      <h6>
                                        {this.context.selectedProduct.setupCharges.toLocaleString(
                                          "en-IN",
                                          {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 0,
                                            style: "currency",
                                            currency: "INR",
                                          }
                                        )}
                                        <br></br>
                                        <small>(One time Cost)</small>
                                      </h6>
                                    </Col>
                                  </Form.Group>
                                  <Form.Group
                                    as={Row}
                                    className="mb-1"
                                    controlId="formPlaintextEmail"
                                  >
                                    <Form.Label
                                      column
                                      xd={window.innerWidth > 1200 ? "4" : "6"}
                                      className="text-start"
                                    >
                                      <h6 className="text-muted">
                                        Auto Scaling{" "}
                                        {this.state.autoScale == true
                                          ? "Enabled"
                                          : "Disabled"}
                                        <br /> [Unlimited Customers Access]
                                      </h6>
                                    </Form.Label>
                                    <Col
                                      xd="2"
                                      className="verticalaligncentertd"
                                    >
                                      <Form.Check
                                        style={{ fontSize: "32px" }}
                                        className="fw-bold pt-2"
                                        // label="Select"
                                        checked={this.state.autoScale}
                                        onChange={(e) => {
                                          if (e.target.checked == true) {
                                            this.setState({
                                              transactionCharges: "1.5",
                                            });
                                          } else {
                                            this.setState({
                                              transactionCharges: "0",
                                            });
                                          }

                                          this.setState({
                                            autoScale: e.target.checked,
                                          });
                                        }}
                                      ></Form.Check>
                                    </Col>
                                    <Form.Label
                                      column
                                      xd={window.innerWidth > 1200 ? "6" : "8"}
                                      className="text-center border CornersRoundedSmall p-2"
                                    >
                                      {this.state.transactionCharges > 0 ? (
                                        <>
                                          <h6 style={{ fontSize: "16px" }}>
                                            Transaction Fee{" "}
                                            {this.state.transactionCharges}% on
                                            Online Sale above 1.5 Lakhs Sale.
                                          </h6>
                                          <i>
                                            <b>Note:</b> This will be billed end
                                            of every month
                                          </i>
                                        </>
                                      ) : (
                                        <>
                                          <h6 style={{ fontSize: "16px" }}>
                                            0% Transaction Fee and Limit upto{" "}
                                            {(Math.round(
                                              this.GetBaseCost() / 500
                                            ) +
                                              1) *
                                              500}{" "}
                                            Customers access per Month
                                          </h6>
                                        </>
                                      )}
                                    </Form.Label>
                                  </Form.Group>
                                </>
                              )}
                            </>
                          ) : (
                            <></>
                          )}
                          <hr />
                          <Form.Group
                            as={Row}
                            className="mb-1"
                            controlId="formPlaintextEmail"
                          >
                            <Form.Label column xd="6" className="text-start">
                              <h6 className="text-muted">
                                Select License Tenure
                              </h6>
                            </Form.Label>
                            <Col xd="6">
                              <Form.Select
                                className="border text-center fw-bold"
                                plaintext
                                value={this.state.selectedLicensePeriod}
                                onChange={(e) =>
                                  this.setState({
                                    selectedLicensePeriod: e.target.value,
                                  })
                                }
                              >
                                <option value={6}>6 Months</option>
                                <option value={12}>
                                  1 Year (get 1 month FREE)
                                </option>
                                <option value={24}>
                                  2 years (get 3 months FREE)
                                </option>
                                <option value={36}>
                                  3 Years (get 6 months FREE)
                                </option>
                              </Form.Select>
                            </Col>
                          </Form.Group>
                          <hr />
                          <Form.Group
                            as={Row}
                            className="mb-1"
                            controlId="formPlaintextEmail"
                          >
                            <Form.Label
                              column
                              xd={window.innerWidth > 1200 ? "4" : "6"}
                              className="text-start"
                            >
                              <h6 className="text-muted">
                                Sub.Total (based on selected License Tenure)
                              </h6>
                            </Form.Label>
                            {window.innerWidth > 1200 ? (
                              <>
                                <Col sm={4}></Col>
                              </>
                            ) : (
                              <></>
                            )}
                            <Form.Label
                              column
                              xd={window.innerWidth > 1200 ? "4" : "6"}
                              className="text-center"
                            >
                              <h6>
                                {this.GetSubTotal().toLocaleString("en-IN", {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 0,
                                  style: "currency",
                                  currency: "INR",
                                })}
                              </h6>
                            </Form.Label>
                          </Form.Group>
                          {this.context.selectedProduct.discount > 0 ? (
                            <>
                              <Form.Group
                                as={Row}
                                className="mb-1"
                                controlId="formPlaintextEmail"
                              >
                                <Form.Label
                                  column
                                  xd={window.innerWidth > 1200 ? "4" : "6"}
                                  className="text-start"
                                >
                                  <h6 className="text-muted">
                                    Discount (
                                    {this.context.selectedProduct.discount}
                                    %)
                                  </h6>
                                </Form.Label>
                                {window.innerWidth > 1200 ? (
                                  <>
                                    <Col sm={4}></Col>
                                  </>
                                ) : (
                                  <></>
                                )}
                                <Form.Label
                                  column
                                  xd={window.innerWidth > 1200 ? "4" : "6"}
                                  className="text-center"
                                >
                                  <h6>
                                    {(
                                      (this.GetSubTotal() *
                                        this.context.selectedProduct.discount) /
                                      100
                                    ).toLocaleString("en-IN", {
                                      minimumFractionDigits: 0,
                                      maximumFractionDigits: 0,
                                      style: "currency",
                                      currency: "INR",
                                    })}
                                  </h6>
                                </Form.Label>
                              </Form.Group>
                            </>
                          ) : (
                            <></>
                          )}
                          {/* <Form.Group
                            as={Row}
                            className="mb-1"
                            controlId="formPlaintextEmail"
                          >
                            <Form.Label column xd="6" className="text-start">
                              <b>Coupon Code (if any) :</b>
                            </Form.Label>
                            <Col>
                              <Stack direction="horizontal">
                                <Form.Control
                                  type="text"
                                  className="bg-white  mx-3"
                                  value={this.state.couponCode}
                                  size="lg"
                                  onChange={(e) => this.onCouponCodeChange(e)}
                                />
                                <Button
                                  className="btn-green-3 text-white "
                                  variant="info"
                                  size=""
                                  onClick={(e) => this.OnClickCouponApply(e)}
                                >
                                  Apply
                                </Button>
                              </Stack>
                            </Col>
                          </Form.Group>
                          {this.state.CouponValue > 0 ? (
                            <>
                              <Form.Group>
                                <Row className="py-1">
                                  <Form.Label column xd="6" className="">
                                    <b>Coupon value </b>
                                  </Form.Label>

                                  <Form.Label
                                    column
                                    xd="6"
                                    className="text-center"
                                  >
                                    {(0).toLocaleString("en-IN", {
                                      minimumFractionDigits: 0,
                                      maximumFractionDigits: 0,
                                      style: "currency",
                                      currency: "INR",
                                    })}
                                  </Form.Label>
                                </Row>
                              </Form.Group>
                            </>
                          ) : (
                            <></>
                          )}
                           */}
                          <hr />
                          <Form.Group
                            as={Row}
                            className="mb-1"
                            controlId="formPlaintextEmail"
                          >
                            <Form.Label
                              column
                              xd={window.innerWidth > 1200 ? "4" : "6"}
                              className="text-start"
                            >
                              <h6 className="text-muted">Total </h6>
                            </Form.Label>
                            {window.innerWidth > 1200 ? (
                              <>
                                <Col sm={4}></Col>
                              </>
                            ) : (
                              <></>
                            )}
                            <Form.Label
                              column
                              xd={window.innerWidth > 1200 ? "4" : "6"}
                              className="text-center"
                            >
                              <h6>
                                {Number(this.GetTotal()).toLocaleString(
                                  "en-IN",
                                  {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0,
                                    style: "currency",
                                    currency: "INR",
                                  }
                                )}
                              </h6>
                            </Form.Label>
                          </Form.Group>
                          <Form.Group
                            as={Row}
                            className="mb-1"
                            controlId="formPlaintextEmail"
                          >
                            <Form.Label
                              column
                              xd={window.innerWidth > 1200 ? "4" : "6"}
                              className="text-start"
                            >
                              <h6 className="text-muted">
                                Tax (
                                {this.context.GetEcSettingValueByName(
                                  "taxPercentage"
                                )}
                                %){" "}
                              </h6>
                            </Form.Label>
                            {window.innerWidth > 1200 ? (
                              <>
                                <Col sm={4}></Col>
                              </>
                            ) : (
                              <></>
                            )}
                            <Form.Label
                              column
                              xd={window.innerWidth > 1200 ? "4" : "6"}
                              className="text-center"
                            >
                              <h6>
                                {Number(
                                  (this.GetTotal() *
                                    this.context.GetEcSettingValueByName(
                                      "taxPercentage"
                                    )) /
                                    100
                                ).toLocaleString("en-IN", {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 0,
                                  style: "currency",
                                  currency: "INR",
                                })}
                              </h6>
                            </Form.Label>
                          </Form.Group>
                          <hr />
                          <Form.Group
                            as={Row}
                            className="mb-1"
                            controlId="formPlaintextEmail"
                          >
                            <Form.Label
                              column
                              xd={window.innerWidth > 1200 ? "4" : "6"}
                              className="text-start"
                            >
                              <h6 className="text-muted">Grand Total </h6>
                            </Form.Label>
                            {window.innerWidth > 1200 ? (
                              <>
                                <Col sm={4}></Col>
                              </>
                            ) : (
                              <></>
                            )}
                            <Form.Label
                              column
                              xd={window.innerWidth > 1200 ? "4" : "6"}
                              className="text-center"
                            >
                              <h5>
                                {Number(this.GetGrandTotal()).toLocaleString(
                                  "en-IN",
                                  {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0,
                                    style: "currency",
                                    currency: "INR",
                                  }
                                )}
                              </h5>
                              [Total Savings:{" "}
                              {this.GetSavingsAmount().toLocaleString("en-IN", {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                                style: "currency",
                                currency: "INR",
                              })}
                              ]
                            </Form.Label>
                          </Form.Group>
                          <hr />
                          <Row className="border-0 my-3 mx-3">
                            <Col
                              sm={12}
                              className="text-start"
                              style={{
                                verticalAlign: "middle",
                                alignItems: "center",
                                display: "flex",
                                fontSize: "16px",
                              }}
                            >
                              <b>
                                <Stack direction="horizontal">
                                  <Stack direction="horizontal">
                                    <Form.Check
                                      checked={
                                        this.state.acceptTermsAndConditions
                                      }
                                      label="by selecting, I agree to the "
                                      onChange={(e) =>
                                        this.setState({
                                          acceptTermsAndConditions:
                                            e.target.checked,
                                        })
                                      }
                                    />
                                    <Nav.Link
                                      as={Link}
                                      to="/TermsAndConditions"
                                      className=""
                                      target="_blank"
                                    >
                                      <u>Terms & Conditions</u>
                                    </Nav.Link>
                                  </Stack>
                                </Stack>
                              </b>
                            </Col>
                          </Row>
                          <Form.Group as={Row} className="px-5">
                            <Button
                              column
                              sm="12"
                              variant="warning"
                              className="CornersRoundedSmall"
                              size="lg"
                              type="submit"
                            >
                              Pay{" "}
                              {Number(this.GetGrandTotal()).toLocaleString(
                                "en-IN",
                                {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 0,
                                  style: "currency",
                                  currency: "INR",
                                }
                              )}{" "}
                            </Button>
                          </Form.Group>
                        </>
                      ) : (
                        <></>
                      )}
                    </div>
                  </Col>
                </Row>
              </Form>
            </div>
          </div>
        </div>
      </>
    );
  }
}
